import subTask from '@/api/project-mgt/sub-task-profile'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  pagination_project: {
    currentPage: 1,
    lastPage: 1,
    perPage: 15,
    total: 6,
    from: 1,
    to: 15
  }
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_PAGINATION_PROJECT(state, value) {
    state.pagination_project = value
  }
}

export const actions = {
  fetch(context, { id, params }) {
    return subTask.get(id, { params })
  },
  store(context, data) {
    return subTask.store(data)
  },
  update(context, { id, data }) {
    return subTask.update(id, data)
  },
  destroy(context, id) {
    return subTask.destroy(id)
  },
  report(context, { id, data }) {
    return subTask.report(id, data)
  },
  getReport(context, id) {
    return subTask.getReport(id)
  },
  subTaskByProject(context, { id, params }) {
    return subTask.subTaskByProject(id, { params })
  },
  importSub(context, data) {
    return subTask.importSub(data)
  },
  downloadTemplate(context, data = {}) {
    return subTask.downloadTemplate(data)
  }
}
